module.exports = "- Use string refs: `ref='root'`\n"